<template>
  <div class="nowrap auction-status-container">
    <div v-if="auction.status === auctionStatuses.DRAFT.value">
      <v-icon color="blue lighten-4">lens</v-icon> Draft
    </div>
    <div v-else-if="auction.status === auctionStatuses.OPEN.value">
      <v-icon color="blue">lens</v-icon> Open
    </div>
    <div v-else-if="auction.status === auctionStatuses.FREEZE.value">
      <v-icon color="blue darken-3">lens</v-icon> Registration Closed
    </div>
    <div v-else-if="auction.status === auctionStatuses.AUCTION.value">
      <v-icon color="green">lens</v-icon> In Auction
    </div>
    <div v-else-if="auction.status === auctionStatuses.PROCESSING.value">
      <v-icon color="orange">lens</v-icon> Processing
    </div>
    <div v-else-if="auction.status === auctionStatuses.IN_ESCROW.value">
      <v-icon color="cyan">lens</v-icon> In Escrow
    </div>
    <div v-else-if="auction.status === auctionStatuses.SOLD.value">
      <v-icon color="gold">lens</v-icon> Sold
    </div>
    <div v-else-if="auction.status === auctionStatuses.CANCELLED.value">
      <v-icon color="grey darken-2">lens</v-icon> Cancelled
    </div>
    <div v-else-if="auction.status === auctionStatuses.CLOSED.value">
      <v-icon color="grey">lens</v-icon> Closed
    </div>
    <div v-else>
      <v-icon color="black">lens</v-icon> {{ auction.status }}
    </div>
  </div>
</template>

<script>
import { auctionStatuses } from '../../utils/PfxUtils.js'
export default {
  name: 'AuctionStatusIndicator',
  props: {
    auction: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      auctionStatuses
    }
  }
}
</script>

<style  lang="scss" scoped>

  .auction-status-container {
    i { font-size: .8rem; } // custom size for v-icon
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/AuctionStatusIndicator.vue